const htmlRegex = /(<([^>]+)>)/gi;

const invalidRecipeSearchCharactersRegex =
  /[^\w\s\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02af\u1d00-\u1d25\u1d62-\u1d65\u1d6b-\u1d77\u1d79-\u1d9a\u1e00-\u1eff\u2090-\u2094\u2184-\u2184\u2488-\u2490\u271d-\u271d\u2c60-\u2c7c\u2c7e-\u2c7f\ua722-\ua76f\ua771-\ua787\ua78b-\ua78c\ua7fb-\ua7ff\ufb00-\ufb06&'+-]|_/gi;

const iphoneSpace = '\u2006';

export const sanitiseRecipeSearchTerm = (value = '') =>
  value
    .replace(htmlRegex, '')
    .replaceAll(iphoneSpace, ' ')
    .replace(invalidRecipeSearchCharactersRegex, '');
